import { useMemo } from "react";
import { SurveyAudienceCriteria} from "src/redux/survey/survey.types";
import { Attribute, localAttributes } from "../components/criteria/criteria-settings";
import { useGetDMAListQuery } from "../redux/questionnaire/questionnaire.endpoints";

export const useAttributeList = (initialFilter?: SurveyAudienceCriteria, dmas?: Attribute) => {
  const { data, isLoading } = useGetDMAListQuery(undefined, { refetchOnMountOrArgChange: true, skip: dmas && dmas.options.length > 0 });

  const attributes: Attribute[] = useMemo(() => {
    let allAttributes = localAttributes;

    if (data) {
      allAttributes = [
        ...localAttributes,
        {
          label: 'Location',
          value: 'DMA',
          options: data,
        },
      ];
    }

    if (dmas && dmas.options.length > 0) {
      allAttributes = [
        ...localAttributes,
        dmas,
      ];
    }

    if (initialFilter) {
      const narrowedAttributes = allAttributes.map((val) => {
        const filter = initialFilter[val.value as keyof SurveyAudienceCriteria];

        if (filter && val) {
          return {
            ...val,
            options: val.options.filter(option => Boolean(filter.find(filt => filt === option.value))),
          };
        }

        return val;
      });

      return narrowedAttributes;
    }

    return allAttributes;
  }, [data, dmas]);

  return { isLoading, attributes };
};
